export default (state, param) => {
  if (param.publicShopKey) {
    state.info.publicShopKey = param.publicShopKey
  }
  if (param.categoryId) {
    state.info.categoryId = param.categoryId
  }
  if (param.message) {
    state.info.message = param.message
  }
  if (param.user) {
    state.info.user = param.user
  }
  if (param.velaeasyDomain) {
    state.info.velaeasyDomain = param.velaeasyDomain
  }
  if (param.hostType) {
    state.info.hostType = param.hostType
  }
  if (param.enable) {
    state.info.enable = param.enable
  }
}
